import * as React from "react";
const SvgWrench = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentColor", stroke: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M42,6l-10,10l4,12l12,4l10,-10l2,8l-11,11l-14,-4l-19,19l-6,-2l-2,-6l19,-19l-4,-14l11,-11z" }));
export default SvgWrench;
